import useMedia from './use-media'
import { useSafeThemeUI } from '../theme-provider/use-theme-ui'
import type { ThemeBreakpoint } from '../themes/theme-keys/breakpoints'
import { defaultBreakpoints } from '../themes/theme-keys/breakpoints'
import { memoizedGet as get } from '../utils/object'

const useTrueAtMediaBreakpointLessThen = (
  breakpoint: ThemeBreakpoint
): boolean => {
  const theme = useSafeThemeUI()
  const breakpoints = get(theme, 'breakpoints', defaultBreakpoints)
  const mediaBreakpoint = `screen and (max-width: ${breakpoints.getValueAndUnit(
    breakpoint
  )})`
  return useMedia([mediaBreakpoint], [true], false)
}

export default useTrueAtMediaBreakpointLessThen
